import React,  { Component } from 'react';
import './SlideShowBanner.scss';
import 'bootstrap';
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';

const properties = {
    showArrows: true,
    infiniteLoop: true,
    swipeable: true,
    showThumbs: false,
    showStatus: false,
    autoPlay: true,
}
class SlideShowBanner extends Component {
    static getAspectRatio = () => {
      return {
        width: 300,
        height: 200,
      }
    }
    constructor(props) {
        super(props);
        this.state = {
            isReady: true,
        };
    }
    componentDidMount = () => {

    }
    render() {
        let bannerItems = this.props.bannerItems
        if (bannerItems.length == 0) {
            return <div className="banner-aspect-ratio" style={{display: "table", width: "100%"}}>
                <div style={{display:"table-cell", textAlign: "center", verticalAlign: "middle"}}>
                    <span className="fa fa-spinner fa-spin"></span>
                </div>
            </div>
        }

        return (
            <div className="slide-container banner-aspect-ratio" style={{}}>
                {
                this.state.isReady &&
                <Carousel {...properties} onClickItem={(index) => {
                    if (bannerItems.length > 0) {
                        let bannerItem = bannerItems[index]
                        // Override behaviour is onClick is passed
                        if (this.props.onBannerClicked) {
                            this.props.onBannerClicked(bannerItem)
                        }

                        // Default behaviour is open the provided url
                        else if (bannerItem.url) {
                            window.open(bannerItem.url, "_blank")
                        }
                    }
                }}>
                    {
                        bannerItems.map((banerItem,index) => {
                            return <div key={index} className="banner-aspect-ratio" style={{}}>
                                <img src={banerItem.image_path} className="banner-aspect-ratio" style={{width: "100%"}}/>
                            </div>
                        })
                    }
                </Carousel>
                }
            </div>
        )
    }
}
export default SlideShowBanner;